module.exports = __webpack_public_path__ + "static/media/1998 Melbourne,  Australia.11c0f159.jpg";